const pricing = [
  {
    id: 1,
    title: 'Basic Plan',
    content: 'Perfect for small businesses',
    price: 20.00,
    unit: 'month',
    features: [
      'Operation',
      'Maintenance',
      'Installation',
      'Quality Components',
      'Battery Materials',
    ],
  },
  {
    id: 2,
    title: 'Advanced Plan',
    content: 'Perfect for big businesses',
    price: 50.00,
    unit: 'month',
    features: [
      'Operation',
      'Maintenance',
      'Installation',
      'Quality Components',
      'Battery Materials',
    ],
  },
  {
    id: 3,
    title: 'Premium Plan',
    content: 'Perfect for enterprise',
    price: 100.00,
    unit: 'month',
    features: [
      'Operation',
      'Maintenance',
      'Installation',
      'Quality Components',
      'Battery Materials',
    ],
  },
];

export default pricing; 